import Grid from "@mui/material/Grid2";
import {Typography, useTheme} from "@mui/material";
import { CommonBar } from "../utils/commonbar";

export const MarginProfilePanel = ({data}) => {
    const theme = useTheme();
    const dims = theme.dimensions;
    const panelTheme = theme.palette.contentPanel;

    const marginData = data || [
        {
            label: 'Customers',
            data: [
                {percent: 25, value: '21', text: '$264K', color: theme.palette.status.success},
                {percent: 25, value: '34', text: '$168K', color: theme.palette.heatmap.success.light},
                {percent: 25, value: '57', text: '$101K', color: theme.palette.status.critical},
                {percent: 25, value: '380', text: '$15K', color: theme.palette.heatmap.critical.light}
            ],
            total: {count: 472, value: '$23K'}
        },
        {
            label: 'Products',
            data: [
                {percent: 25, value: '60', text: '$94K', color: theme.palette.heatmap.success.light},
                {percent: 25, value: '90', text: '$62K', color: theme.palette.status.success},
                {percent: 25, value: '230', text: '$24K', color: theme.palette.heatmap.critical.light},
                {percent: 25, value: '1,290', text: '$4K', color: theme.palette.status.critical}
            ],
            total: {count: 1670, value: '$14K'}
        },
        {
            label: 'Sales Reps',
            data: [
                {percent: 25, value: '20', text: '$280K', color: theme.palette.status.success},
                {percent: 25, value: '30', text: '$215K', color: theme.palette.heatmap.success.light},
                {percent: 25, value: '40', text: '$141K', color: theme.palette.heatmap.critical.light},
                {percent: 25, value: '80', text: '$65K', color: theme.palette.status.critical}
            ],
            total: {count: 170, value: '$134K'}
        }
    ];

    const rows = [];
    for(const row of marginData) {
        rows.push(
            <Grid size={2} display="flex" alignItems="center">
                <Typography variant="body2" sx={{textAlign: "left", marginRight: 2, minWidth: 80}} noWrap>
                    {row.label}:
                </Typography>
            </Grid>,
            <Grid size={8}>
                <CommonBar height={60} data={row.data} showPercent={false}/>
            </Grid>,
            <Grid size={1} display="flex" alignItems="center">
                <Typography variant="body2" style={{fontSize: 12, fontWeight: 500, textAlign: "right"}}>
                    {row.total.count}
                </Typography>
            </Grid>,
            <Grid size={1} display="flex" alignItems="center">
                <Typography variant="body2" style={{fontSize: 12, fontWeight: 500, textAlign: "right"}}>
                    {row.total.value}
                </Typography>
            </Grid>
        );
    }

    return (
        <div style={{...panelTheme, marginTop: 30, padding: 10, width: '100%', minHeight: dims.smallPanelHeight}}>
            <Typography variant="h5" display="inline" style={{cursor: 'pointer'}}>
                Margin Profile
            </Typography>
            <Grid container spacing={1.1} style={{padding: 10}}>
                <Grid size={2}/>
                <Grid size={2}>
                    <Typography variant="body2" style={{fontWeight: 700, fontSize: 12, textDecoration: "underline", textAlign: "center"}}>
                        Top<br/>25%
                    </Typography>
                </Grid>
                <Grid size={4}/>
                <Grid size={2}>
                    <Typography variant="body2" style={{fontWeight: 700, fontSize: 12, textDecoration: "underline", textAlign: "center"}}>
                        Bottom<br/>25%
                    </Typography>
                </Grid>
                <Grid size={1}>
                    <Typography variant="body2" style={{fontWeight: 700, fontSize: 12, textDecoration: "underline", textAlign: "center"}}>
                        <br/>
                        Total
                    </Typography>
                </Grid>
                <Grid size={1}>
                    <Typography variant="body2" style={{fontWeight: 700, fontSize: 12, textDecoration: "underline", textAlign: "center"}}>
                        Avg<br/>Margin
                    </Typography>
                </Grid>
                {rows}
            </Grid>
        </div>
    );
};